// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._0LCBF5AOPKCc4p {\n  color: var(--ds-icon-inverse, #FFFFFF);\n}\n._0IeDY58ZS8sxmn {\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 3px;\n  clear: both;\n  display: block;\n  float: left;\n  margin: 0 0 4px 8px;\n  text-decoration: none;\n  transition: transform 85ms ease-in;\n  color: #c7d1db;\n  padding: 6px 12px 6px 10px;\n}\n._0IeDY58ZS8sxmn:hover {\n  background: rgba(0, 0, 0, 0.8);\n  color: #FFFFFF;\n  transform: translateX(5px);\n}\n.qGNbWJmaYG\\+WAd {\n  margin-left: 6px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "_0LCBF5AOPKCc4p",
	"button": "_0IeDY58ZS8sxmn",
	"buttonLabel": "qGNbWJmaYG+WAd"
};
export default ___CSS_LOADER_EXPORT___;
